// generated from 627_021 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";
import { filterGetSchema } from "./filterGetSchema";

export const orFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("or_filter"),
  display_name: z.string(),
  get filters(): z.ZodArray<z.ZodType<any>> {
    return z.array(filterGetSchema);
  },
  group_name: z.string(),
  // undefined: 257_615 (41.09%), defined 369_406 (58.91%)
  raw_value: z.null().optional(),
  varies_by_app_group: z.literal(false),
});
